import { tv } from "@/utils/tv.config";
import { VariantProps } from "tailwind-variants";

const menuClasses = tv({
  slots: {
    root: "Menu__root ",
    trigger: [
      "flex h-10 items-center justify-center gap-1.5  px-3.5  select-none  focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-1 focus-visible:outline-blue-800",
    ],
    popup: [
      "origin-[var(--transform-origin)] rounded-md bg-[canvas] py-1 text-gray-900  outline outline-1 outline-gray-300 transition-[transform,scale,opacity] data-[ending-style]:scale-90 data-[ending-style]:opacity-0 data-[starting-style]:scale-90 data-[starting-style]:opacity-0  dark:-outline-offset-1 dark:outline-gray-300 max-h-[300px] overflow-y-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]",
    ],
    portal: [""],
    positioner: ["outline-none"],
    icon: ["-mr-1"],
  },
  variants: {},
});

export const {
  root: menuRootClasses,
  trigger: menuTriggerClasses,
  popup: menuPopupClasses,
  portal: menuPortalClasses,
  positioner: menuPositionerClasses,
  icon: menuIconClasses,
} = menuClasses();

export type CounterIconVariants = VariantProps<typeof menuRootClasses>;
